import React from 'react';
import { StyledHeader } from './Header.styles';
import Button from '../Button';
import ModalContainer from '../ModalContainer';
import AgentDetailModal from '../AgentDetailModal';
import ShareModal from '../ShareModal';

const Header = () => {
  return (
    <>
      <StyledHeader>
        <a href="/upgrade-plan">
          <Button width="120px">Upgrade</Button>
        </a>
        {/* <ModalContainer
          width="700"
          title="Share “Transcript”"
          content={({ onClose }) => <ShareModal onClose={onClose} />}
          btnComponent={({ onClick }) => (
            <Button width="120px" onClick={onClick}>
              Upgrade
            </Button>
          )}
        /> */}
        {/* Modals */}
        {/* <AgentDetailModal /> */}
        {/* <ChatDeleteModal /> */}
        {/* <ShareModal /> */}
      </StyledHeader>
    </>
  );
};

export default Header;
